/// <reference path="../app.js"/>

class AboutPage {
	static init() {
		if (!$(document.body).hasClass("AboutPage")) return;

		$(".service .index").each((_index, element) => {
			element.innerText = `${element.innerText.length > 1 ? "" : "0"}${element.innerText}`;
		});

		$(".team .carousel").slick({
			centerMode: true,
			variableWidth: true,
			slidesToShow: 3,
			arrows: true,
			dots: false,
			autoplay: false
		});

		$(".studio-images .carousel").slick({
			centerMode: true,
			arrows: true,
			dots: true,
			autoplay: true,
			autoplaySpeed: 5000
		});

		document.body.dispatchEvent(new Event("fx-reflow", { bubbles: true }));
	}
}